<template>
  <div id="app">
    <div class="top-nav">
      <SideNav :sections="sections" :activeSection="activeSection" />
      <ThemeToggle :theme="theme" @toggle-theme="toggleTheme" />
    </div>
    <HeroSection />
    <AboutMe />
    <SkillsSection />
    <CollaborationSection />
    <ProjectsSection />
    <TroubleshootingSection />
  </div>
</template>

<script>
import ThemeToggle from "./components/ThemeToggle.vue";
import SideNav from "./components/SideNav.vue";
import HeroSection from "./components/HeroSection.vue";
import AboutMe from "./components/AboutMe.vue";
import SkillsSection from "./components/SkillsSection.vue";
import CollaborationSection from "./components/CollaborationSection.vue";
import ProjectsSection from "./components/ProjectsSection.vue";
import TroubleshootingSection from "./components/TroubleshootingSection.vue";

export default {
  name: "App",
  components: {
    ThemeToggle,
    SideNav,
    HeroSection,
    AboutMe,
    SkillsSection,
    CollaborationSection,
    ProjectsSection,
    TroubleshootingSection,
  },
  data() {
    return {
      theme: "light",
      activeSection: "hero",
      sections: [
        { id: "about", name: "About Me" },
        { id: "skills", name: "Skills" },
        { id: "collaboration", name: "Collaboration" },
        { id: "projects", name: "Projects" },
        { id: "troubleshooting", name: "Troubleshooting" },
      ],
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      for (const section of this.sections.slice().reverse()) {
        const element = document.getElementById(section.id);
        if (element && element.offsetTop <= scrollPosition) {
          this.activeSection = section.id;
          return;
        }
      }
      // 최상단일 경우 Hero를 활성화
      if (window.scrollY < window.innerHeight / 2) {
        this.activeSection = "hero";
      }
    },
    toggleTheme() {
      const newTheme = this.theme === "light" ? "dark" : "light";
      this.theme = newTheme;
      localStorage.setItem("theme", newTheme);
      document.body.setAttribute("data-theme", newTheme);
    },
    setTheme(theme) {
      this.theme = theme;
      document.body.setAttribute("data-theme", theme);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    const savedTheme = localStorage.getItem("theme") || "light";
    this.setTheme(savedTheme);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fira+Code&family=Pretendard:wght@400;700&display=swap");
:root {
  --bg-color: #ffffff;
  --bg-secondary-color: #f5f5f7;
  --text-primary-color: #1d1d1f;
  --text-secondary-color: #555555;
  --card-border-color: #ddd;
  --card-shadow-color: rgba(0, 0, 0, 0.05);
  --point-color: #0071e3;
  --tag-bg-color: #f5f5f7;
  --link-border-color: #0071e3;
  --link-hover-bg-color: #0071e3;
  --link-hover-text-color: #ffffff;
}

[data-theme="dark"] {
  /* Dark Mode Colors */
  --bg-color: #121212;
  --bg-secondary-color: #1a1a1a;
  --text-primary-color: #eaeaea;
  --text-secondary-color: #a0a0a0;
  --card-border-color: rgba(255, 255, 255, 0.1);
  --card-shadow-color: rgba(0, 0, 0, 0);
  --point-color: #39ff14;
  --tag-bg-color: rgba(57, 255, 20, 0.15);
  --link-border-color: #eaeaea;
  --link-hover-bg-color: #39ff14;
  --link-hover-text-color: #121212;
}

html {
  scroll-behavior: smooth;
}

body {
  background-color: var(--bg-color); /* 👈 변수 사용 */
  color: var(--text-primary-color); /* 👈 변수 사용 */
  font-family: "Pretendard", sans-serif;
  margin: 0;
  transition: background-color 0.3s, color 0.3s;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.code-font {
  font-family: "Fira Code", monospace;
}

.top-nav {
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 1001;
  display: flex;
  align-items: center;
  gap: 30px;
}

@media (max-width: 768px) {
  .top-nav {
    display: none;
  }
}
</style>
